export default "__VITE_ASSET__B6l6nVtN__"